<script>
  // # # # # # # # # # # # # #
  //
  //  Masonry Brick
  //
  // # # # # # # # # # # # # #

  // *** IMPORTS
  import { fly } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { navigate } from "svelte-routing";
  import get from "lodash/get";
  import has from "lodash/has";

  // *** COMPONENTS
  import PopUp from "./PopUp.svelte";

  // *** PROPS
  export let item;

  // *** VARIABLES
  let loaded = false;
  let fullScreen = false;
  let hovered = false;
  let src = "";

  // *** CONSTANTS
  const ROOT = "https://res.cloudinary.com/pwr/image/upload/";
  const VIDEO_ROOT = "https://res.cloudinary.com/pwr/video/upload/";
  const REMOTE_FOLDER = "completeworks";
  const imgParams = ",ar_1.7,c_fill,g_auto,f_auto,q_90/";

  // Video
  if (has(item, "header.video")) {
    let path = get(item, "header.video.url", "").replace(
      "https://completeworks.ch",
      ""
    );
    src =
      VIDEO_ROOT +
      REMOTE_FOLDER +
      encodeURI(path.substring(0, path.length - 4) + ".jpg");
  } else {
    // Image
    let path = get(item, "header.featured_image.sizes.original", "").replace(
      "https://completeworks.ch",
      ""
    );
    src = ROOT + "w_" + 600 + imgParams + REMOTE_FOLDER + encodeURI(path);
  }

  const url =
    item.header.parent != "feed"
      ? "/" +
        item.header.grandparent +
        "/" +
        item.header.parent +
        "/" +
        item.header.slug
      : false;

  const dispatch = createEventDispatcher();
</script>

<style lang="scss">
  @import "../_variables.scss";

  .brick {
    position: relative;
    height: 300px;
    margin: 0 8px 8px 0;
    min-width: 100px;
    max-width: 500px;
    flex-basis: 250px;
    flex-grow: 2;
    flex-shrink: 1;
    background: rgba(0, 0, 0, 0.05);
    cursor: pointer;
    display: block;

    &:hover {
      .video-play {
        opacity: 0.9;
        transition: opacity 0.3s ease-out;
      }
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      opacity: 0;
      transition: opacity $slow-easing;
    }

    &.loaded {
      img {
        opacity: 1;
      }
    }

    @include screen-size("small") {
      width: 100%;
      min-width: 100px;
      max-width: unset;
      flex-basis: 100%;
    }
  }

  .video-play {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    opacity: 0.6;
    margin-left: -100px;
    margin-top: -100px;
    transition: opacity 0.3s ease-out;
  }

  .brick:nth-child(4n + 1) {
    flex-basis: 200px;

    @include screen-size("small") {
      flex-basis: 100%;
    }
  }

  .brick:nth-child(4n + 1):nth-child(4n + 2) {
    flex-basis: 260px;

    @include screen-size("small") {
      flex-basis: 100%;
    }
  }

  .brick:nth-child(4n + 1):nth-child(4n + 3) {
    flex-basis: 330px;

    @include screen-size("small") {
      flex-basis: 100%;
    }
  }

  .brick:nth-child(4n + 1):nth-child(4n + 4) {
    flex-basis: 440px;

    @include screen-size("small") {
      flex-basis: 100%;
    }
  }

  .title {
    border-bottom: none;
    font-family: $sans-stack;
    font-size: $font-size-large;
    color: $black;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: block;
    text-align: center;
    line-height: 300px;
    pointer-events: none;

    &.light {
      color: $white;
    }
  }
</style>

<span
  class="brick"
  class:loaded
  on:mouseenter={() => {
    hovered = true;
  }}
  on:mouseleave={() => {
    hovered = false;
  }}
  on:click={() => {
    if (!url) {
      fullScreen = true;
    } else {
      navigate(url);
    }
  }}>
  <img
    {src}
    alt={item.header.title}
    on:load={() => {
      dispatch('brickLoaded');
      loaded = true;
    }} />
  {#if url && hovered}
    <div
      class="title"
      class:light={item.header.light == 1}
      in:fly={{ y: 50, duration: 600 }}
      out:fly={{ y: 40, duration: 300 }}>
      {item.header.title}
    </div>
  {/if}
  {#if item.header.video}
    <svg
      class="video-play"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      stroke-width="0.2">
      <circle cx="12" cy="12" r="10" />
      <polygon points="10 8 16 12 10 16 10 8" />
    </svg>
  {/if}
</span>

{#if fullScreen}
  <PopUp
    {item}
    on:close={() => {
      fullScreen = false;
    }} />
{/if}
